const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsClube = { name: 'Clube', pathName: null, action: 'clube' }

export default [
  {
    path: '/clube',
    component: () => import('@/modules/clube/views/pages/Clube.vue'),
    children: [
      {
        path: 'desempenho',
        name: 'desempenho',
        component: () => import('@/modules/clube/desempenho/views/pages/Desempenho.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClube,
            {
              name: 'Desempenho',
              pathName: null,
            },
          ],
          title: 'Desempenho',
          pagePermission: 'clube/desempenho',
        },
      },
      {
        path: 'comparativo',
        component: () => import('@/modules/clube/desempenho/views/pages/Comparativo.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClube,
            {
              name: 'Comparativo',
              pathName: null,
            },
          ],
          title: 'Comparativo',
          pagePermission: 'clube/comparativo',
        },
      },
      {
        path: 'dashboard',
        component: () => import('@/modules/clube/dashboard/views/pages/Dashboard.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClube,
            {
              name: 'Dashboard',
              pathName: null,
            },
          ],
          title: 'Dashboard',
          pagePermission: 'clube/dashboard',
        },
      },
      {
        path: 'lojas',
        component: () => import('@/modules/clube/lojas/views/pages/Lojas.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClube,
            {
              name: 'Lojas',
              pathName: null,
            },
          ],
          title: 'Lojas',
          pagePermission: 'clube/lojas',
        },
      },
      {
        path: 'performance-operacional',
        component: () => import('@/modules/clube/performance-operacional/views/pages/PerformanceOperacional.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClube,
            {
              name: 'Performance operacional',
              pathName: null,
            },
          ],
          title: 'Performance operacional',
          permission: 'operational_performance',
          pagePermission: 'clube/performance_operacional',
          requiresPiiEmployeesAccess: true,
        },
      },
      {
        path: 'performance-operacional/detalhes-operador/:id',
        component: () => import('@/modules/clube/performance-operacional/views/pages/DetalhesOperador.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsClube,
            {
              name: 'Performance Operacional',
              pathName: '/clube/performance-operacional',
            },
            {
              name: 'Detalhes Operador',
              pathName: null,
            },
          ],
          title: 'Detalhes Operador',
          permission: 'operational_performance',
          pagePermission: 'clube/performance_operacional',
          requiresPiiEmployeesAccess: true,
        },
      },
    ],
  },
]
